import { LoginComponent } from "./component";

export const Login = LoginComponent;
